module.exports = __webpack_public_path__ + "res/0-img_winner.e52932ac4bcb432dd2dc6a28c9dfd14d.png";